import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-end"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", { class: "m-5" }, null, -1)
const _hoisted_4 = { class: "flex flex-row flex-nowrap card-header border-0" }
const _hoisted_5 = { class: "flex card-toolbar w-full" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "p-input-icon-left w-10/12" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar w-full" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col justify-center" })
], -1)
const _hoisted_10 = { class: "card-toolbar w-full" }
const _hoisted_11 = {
  key: 0,
  class: "flex justify-end"
}
const _hoisted_12 = { class: "card-body pt-0" }
const _hoisted_13 = {
  key: 0,
  class: "text-center bg-green-100 text-green-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded-full dark:bg-green-900 dark:text-green-300"
}
const _hoisted_14 = {
  key: 1,
  class: "text-center bg-red-100 text-red-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded-full dark:bg-red-900 dark:text-red-300"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", null, "Actions", -1)

import { ref, onMounted } from "vue";
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputSwitch from "primevue/inputswitch";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import { useRoute } from "vue-router";
import { getPaginateBackOfficeUsersBySupplier } from "@/_services/supplier/backOfficeSupplier/backofficeSupplier";
import { ISortType } from "@/models/backOfficeSupplier/ISortType";
import { IBackOfficeSupplierUser } from "@/models/backOfficeSupplier/IBackOfficeSupplierUser";

import BackOfficeUserCreateFormModal from "@/components/modal/backOfficeUser/backOfficeUserCreateFormModal.vue";
import Swal from "@/_helpers/swal";
import {filterService} from "@/_services/filter/category/filter";

const addBackOfficeUserFormModalid = "addBackOfficeUserFormModal";
const localStorageKey = "supplierBackOfficeUser";
const defaultRowsPerPage = 10;

export default /*#__PURE__*/_defineComponent({
  __name: 'BackOfficeSupplierList',
  setup(__props) {

const isLoading = ref<boolean>(true);
const backOfficeUsersSuppliers: IBackOfficeSupplierUser[] = [];
const tableData = ref<Array<IBackOfficeSupplierUser>>(backOfficeUsersSuppliers);
const firstBackOfficeUserSupplier = ref<IBackOfficeSupplierUser | undefined>(undefined);
const currentPage = ref<number>(0);
const rows = ref<number>(10);
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const criteria = ref<string>("");
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];
const defaultsSort = {
    fieldLabel: "order[createdAt]",
    fieldValue: "desc",
};
const route = useRoute();
const supplierUuidFromUrl: string = route.params.uuid ? route.params.uuid.toString() : "";
onMounted(async () => {
    if (supplierUuidFromUrl.length) {
        await populateDataTableWithLocalStorageFilters(supplierUuidFromUrl);
    }
});

function onSearchInputDt() {
    if (supplierUuidFromUrl.length) {
        populateDatatable(supplierUuidFromUrl, rows.value, page.value, criteria.value);
    }
}

async function populateDatatable(
    supplierUuidFromUrl: string,
    itemsPerPage: number,
    page: number,
    criteria?: string,
    sort?: ISortType,
) {
    showSpinner();
    const [loadingDt, totalRecordsDt, tableDataDt] = await getPaginateBackOfficeUsersBySupplier(
        supplierUuidFromUrl,
        itemsPerPage,
        page,
        criteria,
        sort,
    );
    isLoading.value = loadingDt.value;
    totalRecords.value = totalRecordsDt.value;
    tableData.value = tableDataDt.value;

    firstBackOfficeUserSupplier.value = tableData.value[0];
}

async function populateDataTableWithLocalStorageFilters(
    supplierUuidFromUrl,
    itemsPerPage?: number,
    page?: number
) {
    if (supplierUuidFromUrl.length) {
        let sort: ISortType | undefined  = undefined;
        let localStorageData = getLocalStorageData();
        if (null !== localStorageData) {
            if (localStorageData?.sortField && localStorageData?.sortOrder) {
                sort = {
                    fieldLabel: "order[" + localStorageData.sortField + "]",
                    fieldValue: localStorageData.sortOrder === 1 ? "asc" : "desc"
                };
            }
        }

        let localStorageRowPerPage = getLocalStorageRowsPerPage();
        let localStorageFisrtPageState = getLocalStorageFisrtPageState();
        let currentPage = page;
        if (!currentPage) {
            currentPage = localStorageFisrtPageState / localStorageRowPerPage + 1;
        }
        let currentItemsPerPage = itemsPerPage;
        if (!currentItemsPerPage) {
            currentItemsPerPage = localStorageRowPerPage;
        }

        populateDatatable(supplierUuidFromUrl, currentItemsPerPage as number, currentPage, criteria.value, sort);
    }
}

const onSort = (e) => {
    if (supplierUuidFromUrl.length) {
        if (e.sortField) {
            rows.value = e.rows;
            setLocalStorageRowsPerPage(rows.value);
            const sort = {
                fieldLabel: "order[" + e.sortField + "]",
                fieldValue: e.sortOrder === 1 ? "asc" : "desc"
            };
            populateDatatable(supplierUuidFromUrl, rows.value, page.value, criteria.value, sort);
        } else {
            populateDatatable(supplierUuidFromUrl, rows.value, page.value, criteria.value, defaultsSort);
        }
    }
};

async function onPaginate(e) {
    rows.value = e.rows;
    page.value = e.page + 1;
    if (supplierUuidFromUrl.length) {
        setLocalStorageRowsPerPage(rows.value);
        populateDataTableWithLocalStorageFilters(supplierUuidFromUrl, rows.value, page.value);
    }
}

function getLocalStorageData() {
    let storageData = localStorage.getItem(localStorageKey);
    
    if (null !== storageData && "undefined" !== storageData) {
        return JSON.parse(storageData);
    }

    return null;
}

function setLocalStorageRowsPerPage(rowPerPage: number) {
    let storageData = localStorage.getItem(localStorageKey);
    if (null !== storageData) {
        let localStorageObject = JSON.parse(storageData);
        localStorageObject.rows = rowPerPage;
        localStorage.setItem(localStorageKey, JSON.stringify(localStorageObject));
    }
}

function getLocalStorageRowsPerPage() {
    let localStorageData = getLocalStorageData();
    if (null !== localStorageData && localStorageData.rows) {
        return localStorageData.rows;
    }

    return defaultRowsPerPage;
}

function getLocalStorageFisrtPageState() {
    let localStorageData = getLocalStorageData();
    if (null !== localStorageData && localStorageData.first) {
        return localStorageData.first;
    }

    return 0;
}

async function deleteBackOfficeSupplierUser(uuid: string) {
    await swal
        .confirm(
            "Êtes-vous sûr de vouloir supprimer ce utilisateur du back office ?",
            "Annuler",
            "Oui, supprimer",
        )
        .then((result) => {
            if (result.isConfirmed) {
                ApiService.delete("back_office_user_suppliers/" + uuid)
                .then(() => {
                    swal.info("Utilisateur supprimé du back office").then(() => {
                      populateDataTableWithLocalStorageFilters(supplierUuidFromUrl);
                    });
                })
                .catch(() => {
                  Swal.error("La suppression a échoué veuillez réessayer.");
                });
            }
        });
}

async function toggleBackOfficeStatusAndLinkedUsers(backOfficeUserSupplier: IBackOfficeSupplierUser, isActive: boolean) {
    await swal
        .confirm(
            isActive ? "Êtes-vous sûr de vouloir activer le back office ? tous les utilisateurs seront activés" : "Êtes-vous sûr de vouloir désactiver le back office ? tous les utilisateurs seront désactivés",
            "Annuler",
            isActive ? "Oui, activer" :  "Oui, désactiver"
        )
        .then((result) => {
            showSpinner();
            let infoSuccessMsg = isActive ? "Les utilisateurs ont été activés" : "Les utilisateurs ont été désactivés"
            if (result.isConfirmed) {
                ApiService.patchWithoutSlug("/back-office-supplier-edit-users/" + backOfficeUserSupplier.uuid, { isActive: isActive })
                .then(() => {
                    swal.info(infoSuccessMsg).then(() => {
                      populateDataTableWithLocalStorageFilters(supplierUuidFromUrl);
                    });
                })
                .catch(() => {
                  Swal.error("une erreur est survenue, veuillez réessayer.");
                });
            }
        });
}

async function toggleUserStatus(
    userUuid: string,
    isActive: string,
    confirmMessage: string,
    successMessage: string,
    cancelButtonText?: string,
    confirmButtonText?: string,           
    confirmButtonClass?: string,
    cancelButtonClass?: string,
) {
    await swal
        .confirm(
            confirmMessage,
            cancelButtonText,
            confirmButtonText,
            confirmButtonClass,
            cancelButtonClass
        )
        .then((result) => {
            if (result.isConfirmed) {
                showSpinner();
                ApiService.patchWithoutSlug("users/edit-status/" + userUuid, { isActive: isActive })
                .then(() => {
                    swal.info(successMessage);
                    hideSpinner();
                })
                .catch(() => {
                  Swal.error("une erreur est survenue, veuillez réessayer.").then((response: object) => {
                      if (response.isConfirmed) {
                          hideSpinner();
                          populateDatatable(supplierUuidFromUrl, rows.value, page.value, criteria.value);
                      }
                  });
                });
            } else {
              populateDatatable(supplierUuidFromUrl, rows.value, page.value, criteria.value);
            }
        });
}

const redirectToEditUserPage = (userUuid: string) => {
    return "ok"
;};

const addNewBackOfficeUser = () => {
    const backOfficeUserCreateFormModalElement:HTMLDialogElement | null = document.querySelector(`#${addBackOfficeUserFormModalid}`);
    if (backOfficeUserCreateFormModalElement) {
        backOfficeUserCreateFormModalElement.showModal();
    }
};

const showSpinner = () => {
    isLoading.value = true;
}

const hideSpinner = () => {
    isLoading.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(DataTable), {
      lazy: "",
      dataKey: "uuid",
      stateStorage: "local",
      ref: "dt",
      "state-key": localStorageKey,
      value: tableData.value,
      paginator: true,
      rows: rows.value,
      rowHover: true,
      sortMode: "single",
      removableSort: "",
      metaKeySelection: false,
      loading: isLoading.value,
      totalRecords: totalRecords.value,
      currentPage: currentPage.value,
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
      rowsPerPageOptions: rowsPerPageOptions,
      currentPageReportTemplate: "Affichage de {first} à {last} sur {totalRecords} entrées",
      onPage: _cache[5] || (_cache[5] = ($event: any) => (onPaginate($event))),
      onSort: _cache[6] || (_cache[6] = ($event: any) => (onSort($event)))
    }, {
      header: _withCtx(() => [
        (firstBackOfficeUserSupplier.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_unref(Button), {
                size: "small",
                title: "Activer/désactiver les utilisateurs",
                class: "btn p-button-success",
                style: {"margin-right":"0.5em"},
                onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleBackOfficeStatusAndLinkedUsers(firstBackOfficeUserSupplier.value, true)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Activer les utilisateurs ")
                ]),
                _: 1
              }),
              _createVNode(_unref(Button), {
                size: "small",
                title: "Activer/désactiver les utilisateurs",
                class: "btn p-button-danger",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleBackOfficeStatusAndLinkedUsers(firstBackOfficeUserSupplier.value, false)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Désactiver les utilisateurs ")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _hoisted_8,
                _createVNode(_unref(InputText), {
                  type: "text",
                  class: "w-9/12",
                  modelValue: criteria.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((criteria).value = $event)),
                  placeholder: "Recherche par email, nom, prénom",
                  onInput: _cache[3] || (_cache[3] = ($event: any) => (onSearchInputDt()))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            (_unref(supplierUuidFromUrl).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_unref(Button), {
                    size: "small",
                    class: "btn btn-primary p-2 ps-2 pe-2",
                    style: {"margin-right":"0.5em"},
                    title: "Ajouter un forunisseur",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (addNewBackOfficeUser()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Ajouter un utilisateur ")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      empty: _withCtx(() => [
        _createTextVNode("Aucun résultat trouvé.")
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_unref(Column), {
            field: "user.lastname",
            header: "Nom"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(slotProps.data.user.lastname), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "user.firstname",
            header: "Prénom"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(slotProps.data.user.firstname), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "user.email",
            header: "E-mail"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(slotProps.data.user.email), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "user.enabled",
            header: "État",
            sortable: ""
          }, {
            body: _withCtx((slotProps) => [
              (slotProps.data.isActive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Actif "))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, " Inactif "))
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "createdAt",
            header: "Date d'ajout",
            sortable: ""
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(slotProps.data.createdAt), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "createdBy",
            header: "Créé par"
          }, {
            body: _withCtx((slotProps) => [
              (slotProps.data.createdBy !== undefined)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(slotProps.data.createdBy.firstname) + " " + _toDisplayString(slotProps.data.createdBy.lastname), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString("")))
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), { headerStyle: "width: 12em;" }, {
            header: _withCtx(() => [
              _hoisted_17
            ]),
            body: _withCtx((slotProps) => [
              _createVNode(_unref(InputSwitch), {
                style: {"margin-right":"0.5em"},
                modelValue: slotProps.data.isActive,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.isActive) = $event),
                "input-id": slotProps.data.user.uuid,
                onInput: ($event: any) => (toggleUserStatus(
                                slotProps.data.user.uuid,
                                slotProps.data.isActive,
                                slotProps.data.isActive
                                    ? `Êtes-vous sûr de vouloir activer cet utilisateur ?`
                                    : `Êtes-vous sûr de vouloir désactiver cet utilisateur ?`,
                                slotProps.data.isActive ? `Utilisateur activé` : `Utilisateur désactivé`,
                                `Annuler`,
                                slotProps.data.isActive ? `Oui, activer` : `Oui, désactiver`
                            ))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "input-id", "onInput"]),
              _createVNode(_unref(Button), {
                size: "small",
                icon: "pi pi-trash",
                class: _normalizeClass(["p-button-danger", `${slotProps.data.uuid}`]),
                style: {"margin-right":"0.5em"},
                title: "supprimer",
                onClick: ($event: any) => (deleteBackOfficeSupplierUser(slotProps.data.uuid))
              }, null, 8, ["class", "onClick"])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["value", "rows", "loading", "totalRecords", "currentPage"]),
    _createVNode(BackOfficeUserCreateFormModal, {
      "supplier-uuid": _unref(supplierUuidFromUrl),
      "add-back-office-user-form-modalid": addBackOfficeUserFormModalid
    }, null, 8, ["supplier-uuid"])
  ]))
}
}

})